import { UUID_REGEXP } from './regular-expressions';

export type Uuid = string;
export type Guid = Uuid;

export function isUuid(value: unknown): value is Uuid {
  if (typeof value !== 'string') {
    return false;
  }
  return value.match(UUID_REGEXP) !== null;
}
